export default __webpack_public_path__ + "static/media/ashirvadLandscape.6d025757.png";